import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getReturnsGridDataAction,
    getPerfCalendarYrsDataAction,
    getTrailingPerfDataAction,
    getCalYrsVsBMDataAction,
    getSummaryTabDataAction,
    getBMDDHistoryDataAction,
    getCumulativeChart,
    getVamiChartData,
    getDistReturnsChartData,
    getRollingChartData,
} from "../../../../actions/returnsGridAction";

import { getAssetSettings } from "../../../../actions/assetSettingsAction";
import { SBAComboBox } from "../../../../UiComponents/SBADropDown";
import { BreadCrumbs } from "../../../../shared/breadCrumbs/BreadCrumbs";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingScreen } from "../../../../UiComponents/LoadingComponent";
import { exportToExcel } from "../../../../utils/excelExporter";
import { getMinMaxReturnDates,getStatSummary } from "../../../../../config/apiConfig";
import axios from "axios";
import stared from "../../../../asset/returnsandstatistics/images/stared.svg";
import burgermenu from "../../../../asset/returnsandstatistics/images/burger-menu.svg";
import linechartup from "../../../../asset/returnsandstatistics/images/line-chart-up-01.svg";
import download from "../../../../asset/returnsandstatistics/images/download.svg";
import asset from "../../../../asset/returnsandstatistics/images/assets.svg";
import moment from "moment";
import { DateRangePicker } from "rsuite";
import { UrlPath } from "../../../../../config/routeConfig";
import { ReturnsTab, VamiChart, RollingChart, CumulativeReturnsChart, DistReturnsChart } from "../../../../asset/returnsandstatistics/ReturnsTab";
import SummaryTab from "../../../../asset/returnsandstatistics/SummaryTab";
import { TopBar } from "../../../../shared/topBar/TopBar";
import Settingicon from '../../../../asset/Images/settings.svg';
import { getAllMarketDataIndices, getMarketDataDetails } from '../../../../actions/marketDataAction';
import { sbaAxios } from "../../../../utils/sbaAxios";
import { getCustomSettings } from "../../../../../config/apiConfig";
import { StatChoice, StatOption, StatType } from "../../../../../config/statSummaryConfig";
import { SBDateRangePicker } from "../../../../UiComponents/SBDateRangePicker";
import { SBNotify } from "../../../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
export const MarketAnalytics = () => {
    const Gstate =
        useSelector((state) => {
            return state;
        }) || {};
    const isEditable = Gstate.authorizationData.isEditable;
    const marketlistdata = Gstate.Marketdata?.Indices || [];
    const marketdatadetails = Gstate.Marketdata?.Marketdatadetails || {};

    const [Loading, setLoading] = useState(true);
    const [render, setRender] = useState(true);
    const [selectedTabOption, setSelectedTabOption] = useState("0");
    const [buttonGo, setbuttonGo] = useState(true);
    const [gridView, setGridView] = useState(true);
    const [chartView, setChartView] = useState(false);
    const [gridbuttonActive, setGridbuttonActive] = useState(true);
    const [chartbuttonActive, setChartbuttonActive] = useState(false);
    const ReturnsExcel = useRef();
    const CalendarExcel = useRef();
    const [posNegLen, setPosNegLen] = useState([]);
    const [radioValue, setRadioValue] = useState(4);
    const [flagValues, setFlagValues] = useState(false);
    const [BM1, setBM1Values] = useState([]);
    const [BM2, setBM2Values] = useState([]);
    const [bM1Id, setBM1Id] = useState([]);
    const [bM2Id, setBM2Id] = useState([]);
    const [showIcon, setShowIcon] = useState(false);
    const [cancelShow, setcancelshow] = useState(false);
    const [updateShow, setupdateshow] = useState(true);
    const [errorMsg, setErrorMsg] = useState(false);
    const [mktValue, setMktValue] = useState(marketdatadetails);
    const [customRange, setCustomRange] = useState(false);
    const [IsSave, setIsSave] = useState(false);
    const [SummaryWidgetCollections, setSummaryWidgetCollections] = useState([]);
    const [WidgetPosition, setWidgetPosition] = useState([]);
    const params = useParams();
    const history = useNavigate();
    const dispatch = useDispatch();
    const [selectedChartButton, setSelectedChartButton] = useState('VAMI');
    const [summarydata,setSummarydata]=useState([]);
    const chartButtonClick = (buttonName) => {
        const startingDate = startDate instanceof Date ? startDate.toISOString() : new Date().toDateString();
        const endingDate = endDate instanceof Date ? endDate.toISOString() : new Date().toDateString();
        setSelectedChartButton(buttonName);
        if (gridbuttonActive)
            dispatch(getReturnsGridDataAction(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (!gridbuttonActive && buttonName === 'CUMM')
            dispatch(getCumulativeChart(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (!gridbuttonActive && buttonName === 'VAMI')
            dispatch(getVamiChartData(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (!gridbuttonActive && buttonName === 'DISTR')
            dispatch(getDistReturnsChartData(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (!gridbuttonActive && buttonName === 'Rolling')
            dispatch(getRollingChartData(params.MarketIndexId, bM1Id, bM2Id));
    };

    useEffect(() => {
        marketdatadetails && marketlistdata && setLoading(false);
    }, [Gstate]);

    const getCustomSetting = () => {
        sbaAxios({ url: `${getCustomSettings}1005` })
            .then((response) => {
                if (response) {
                    const widgetSettings = JSON.parse(response.CustomSettingsValue);
                    setSummaryWidgetCollections(widgetSettings);
                    const data = widgetSettings.map((item) => item.dataPosition);
                    setWidgetPosition(data);

                }

            })
            .catch((error) => {
                console.log(error);
            });

    };

    const returnsGrid = Gstate.ReturnsGridData.ReturnsGridData;
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const BM = Gstate.assetSettings?.assetSetting;
    useEffect(() => {
        document.title = `Analytics`;
    }, [])
    useEffect(() => {
        getCustomSetting();
        const startingDate = returnsGrid?.StartDate ? new Date(returnsGrid?.StartDate) : new Date();
        const endingDate = returnsGrid?.EndDate ? new Date(returnsGrid?.EndDate) : new Date();
        setStartDate(startingDate);
        setEndDate(endingDate);

        let total = 0;
        const lenMonths = returnsGrid?.ReturnsGrid;
        if (lenMonths != undefined)
            lenMonths.forEach((parent) => {
                const dt=  parent.Months.filter(item => item.ReturnValue !=null);
                total += dt.length;
            });
        setPosNegLen(total);
        setBM1Values(BM.Benchmarks?.[0]?.BMEntityName);
        setBM2Values(BM.Benchmarks?.[1]?.BMEntityName);
        setBM1Id(BM.Benchmarks?.[0]?.BMEntityId);
        setBM2Id(BM.Benchmarks?.[1]?.BMEntityId);
    }, [returnsGrid, BM]);

    useEffect(() => {
        getMinMaxValues();
        dispatch(getMarketDataDetails(params.MarketIndexId))
        dispatch(getAllMarketDataIndices());
        dispatch(getAssetSettings(params.MarketIndexId, 3));
    }, [render, params]);


    const tabOptionChange = (event, oldTabOption) => {
        setSelectedTabOption(oldTabOption || event?.target?.value);
        const MarketIndexId = event?.value?.MarketIndexId || params.MarketIndexId
        const selectedoption = radioValue === 5 ? StatOption.StatCustomOption : StatOption.StatSummaryOption;
        if (event?.target?.value === "1" || oldTabOption === "1") {
            const isvalidate=  validateDateRange(startDate,endDate);
            if(isvalidate)
            SBNotify({ type: "error", Msg: "Please select a minimum of 1 year for the summary" });
            else
            {
          // dispatch(getAssetSettings(MarketIndexId, 3));
           // dispatch(getSummaryTabDataAction(MarketIndexId, StatType.MarketData, startDate, endDate, StatOption.StatSummaryOption, StatChoice))
           getSummaryData(MarketIndexId, StatType.MarketData, startDate, endDate, selectedoption,99)
           dispatch(
                getBMDDHistoryDataAction(MarketIndexId, 3, startDate, endDate, selectedoption)
            );
            dispatch(getCalYrsVsBMDataAction(MarketIndexId, 3, startDate, endDate, selectedoption));
           }
        }

        if (event.target.value === "2") {
            dispatch(
                getPerfCalendarYrsDataAction(params.MarketIndexId, 3, startDate, endDate, selectedoption)
            );
            dispatch(
                getTrailingPerfDataAction(params.MarketIndexId, 3, startDate, endDate, selectedoption)
            );
        }
    };

    //button trigger here for initial load

    useEffect(() => {
        const startingDate = startDate instanceof Date ? startDate.toISOString() : new Date().toDateString();
        const endingDate = endDate instanceof Date ? endDate.toISOString() : new Date().toDateString();
        if (gridbuttonActive)
            dispatch(getReturnsGridDataAction(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (!gridbuttonActive && selectedChartButton === 'CUMM')
            dispatch(getCumulativeChart(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (!gridbuttonActive && selectedChartButton === 'VAMI')
            dispatch(getVamiChartData(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (!gridbuttonActive && selectedChartButton === 'DISTR')
            dispatch(getDistReturnsChartData(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (!gridbuttonActive && selectedChartButton === 'Rolling')
            dispatch(getRollingChartData(params.MarketIndexId, bM1Id, bM2Id));
    }, [radioValue, render, params])

    const AssestDDChanged = (e) => {
        e.value
            ? history(`${UrlPath.MarketAnalytics}${e.value.MarketIndexId}`)
            : history(`${UrlPath.MarketAnalytics}${params.MarketIndexId}`);
        getMinMaxValues();
        tabOptionChange(e, selectedTabOption);
        setMktValue(e.value);
    };
    const handleDateChange = (e) => {
       
        if (e) {

            const newStartDate = e.value.start !== null ? e.value.start : startDate;
            const newEndDate = e.value.end !== null ? e.value.end : endDate;

            setStartDate(newStartDate);
            setEndDate(newEndDate);
        }
        setFlagValues(true);
        setCustomRange(true);
    };

    const gobtnClick = () => {
        if (true) {
            const startingDate = startDate instanceof Date ? startDate.toISOString() : new Date().toISOString();
            const endingDate = endDate instanceof Date ? endDate.toISOString() : new Date().toISOString();
            setRadioValue(5);
            setCustomRange(true);
            setFlagValues(true);

            if (selectedTabOption === "0" && gridView == true) {
                dispatch(
                    getReturnsGridDataAction(
                        params.MarketIndexId,
                        3,
                        startingDate,
                        endingDate,
                        radioValue
                    )
                );
            }
            else
            { 
                const isvalidate = validateDateRange(startDate ? startDate : new Date(), endDate ? endDate : new Date());
                if (isvalidate)
                    SBNotify({ type: "error", Msg: "Please select a minimum of 1 year for the summary" });
                else {
                    getSummaryData(params.MarketIndexId, StatType.MarketData, startDate, endDate, radioValue, 99)
                    dispatch(
                        getBMDDHistoryDataAction(params.MarketIndexId, 3, startDate, endDate, radioValue)
                    );
                    dispatch(getCalYrsVsBMDataAction(params.MarketIndexId, 3, startDate, endDate, radioValue));
                }
            }
        }
    };
    const ResetbtnClick = () => {
        getMinMaxValues();
    }
    const  validateDateRange=(startDate, endDate) =>{
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffInYears = (end - start) / (1000 * 60 * 60 * 24 * 365);
        if (diffInYears < 1) {
            return true;
        } 
    }
    const ReturnGridValue = () => {
        const startingDate = startDate instanceof Date ? startDate.toISOString() : new Date().toDateString();
        const endingDate = endDate instanceof Date ? endDate.toISOString() : new Date().toDateString();

        setbuttonGo(true);
        setGridView(true);
        setChartView(false);
        setGridbuttonActive(true);
        setChartbuttonActive(false);
        dispatch(
            getReturnsGridDataAction(
                params.MarketIndexId,
                3,
                startingDate,
                endingDate,
                radioValue
            )
        );

    };
    const ReturnChartValue = () => {
        setGridView(false);
        setChartView(true);
        setGridbuttonActive(false);
        setChartbuttonActive(true);
        const startingDate = startDate instanceof Date ? startDate.toISOString() : new Date().toDateString();
        const endingDate = endDate instanceof Date ? endDate.toISOString() : new Date().toDateString();
        if (selectedChartButton === 'CUMM')
            dispatch(getCumulativeChart(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (selectedChartButton === 'VAMI')
            dispatch(getVamiChartData(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (selectedChartButton === 'DISTR')
            dispatch(getDistReturnsChartData(params.MarketIndexId, 3, startingDate, endingDate, radioValue));
        else if (selectedChartButton === 'Rolling')
            dispatch(getRollingChartData(params.MarketIndexId, bM1Id, bM2Id));
    };

    function updateSummarySettingsButton() {
        setShowIcon((prevShowIcon) => !prevShowIcon);
        setcancelshow(true);
        setupdateshow(false);
    };

    function cancelSummarySettingsButton() {
        setupdateshow(true);
        setcancelshow(false);
        setShowIcon(false);
    };

    function SetSaveSettings() {
        setIsSave(true);
    };

    let Level = [];
    Level = Loading
        ? Level
        : [
            ...Level,
            {
                BreadCrumb: `Market Data >`,
                Routes: `${UrlPath.MarketData}`,
            },
            {
                BreadCrumb: `${marketdatadetails?.MarketIndexName} >`,
                Routes: `${UrlPath.MarketDataDetails}${params.MarketIndexId}`,
            },
            { BreadCrumb: "Analytics", Routes: `${UrlPath.MarketAnalytics}` }
        ];
    const defaultColDef = {
        sortable: false,
        filter: false,
        suppressMovable: true,
    };

    const handleButtonClick = () => {
        history(`${UrlPath.MarketAnalyticsPostPricing}${params.MarketIndexId}`, { state: { ActiveTab: "AnalyticsandReporting", currentAssetId: params.MarketIndexId } });
    };
    const options = [
        { value: "0", label: "Returns" },
        { value: "1", label: "Summary" },

    ];
    const chartButtonNames = [
        { value: "0", label: "CUMM" },
        { value: "1", label: "DISTR" },
        { value: "2", label: "Rolling" },
        { value: "3", label: "VAMI" },
    ];
    const getstdYear = (event) => {
        let year = 0;
        let TodayDate = new Date();
        switch (event.target.innerText) {
            case "1Y":
                year = 0;
                break;
            case "3Y":
                year = 1;
                break;
            case "5Y":
                year = 2;
                break;
            case "10Y":
                year = 3;
                break;
            case "ITD":
                year = 4;
                break;
        }
        setRadioValue(year);
        setEndDate(TodayDate);
        setStartDate(TodayDate);
    };


    const getMinMaxValues = async () => {

        try {
            const response = await sbaAxios({
                url: `${getMinMaxReturnDates}${params.MarketIndexId},${3},${3}`,
                method: 'get',
            });

            const MinMaxDateValue = {
                MinDate: response.StartDate,
                MaxDate: response.EndDate,
            };

            if (MinMaxDateValue.MinDate !== null && MinMaxDateValue.MaxDate !== null) {
                setStartDate(MinMaxDateValue.MinDate);
                setEndDate(MinMaxDateValue.MaxDate);
                setErrorMsg(false);
            }
            else {
                setErrorMsg(true);
            }

        } catch (error) {
            console.error('Error fetching min/max values:', error);

        }

    };
    const getSummaryData=async(entityId, entityType, startDate, endDate, opt)=>
    {
        try {
            const response = await sbaAxios({
              url: `${getStatSummary}${entityId},${entityType},${startDate},${endDate},${opt},${99}`,
              method: 'get'
            });
    
            const SummaryTabData = response;
    
            setSummarydata(SummaryTabData);
             return SummaryTabData;
    }
    catch (error) {
        
        return null; 
      }
}
    return (
        <>
            <div id="ReturnsGridDiv">
                {Loading ? (
                    <>
                        <LoadingScreen />
                    </>
                ) : (
                    <>
                        <TopBar label={"Analytics"} />
                        <div>
                            <div id="content" className="analytics mainContentData">
                                <BreadCrumbs Levels={Level} />
                                <>
                                    <div className="analytics-selection bg-white p-4">
                                        <p className="fw-medium fs-6">
                                            Analytics
                                            <span>
                                            </span>
                                        </p>
                                        <div className="row gap-3">
                                            <div className="col-md-4 col-lg-4">
                                                <label htmlFor="select fund" className="mb-1 label">
                                                    Select Index
                                                </label>
                                                <div className="DropDownDiv input-border">
                                                    <SBAComboBox
                                                        filterable={true}
                                                        data={marketlistdata}
                                                        textField={"MarketIndexName"}
                                                        valueField={"MarketIndexId"}
                                                        value={marketdatadetails}
                                                        onChange={AssestDDChanged}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2 col-lg-2">
                                                <label htmlFor="select fund" className="mb-1 label">
                                                    Select Time Series
                                                </label>
                                                <select
                                                    className="form-select"
                                                    aria-label="Default select example"
                                                >
                                                    <option selected>Composite</option>
                                                </select>
                                            </div>
                                            <div className="col-md-2 col-lg-2 d-flex date-gap">
                                                <div className="col-md-12 col-lg-12 example-wrapper">
                                                    <label className="mb-1 label">Select Date Range</label>
                                                    <div className="">
                                                        <SBDateRangePicker
                                                            value={{ start: startDate ? moment(startDate).toDate() : new Date(), end: endDate ? moment(endDate).toDate() : new Date() }}
                                                            onChange={handleDateChange}
                                                        />
                                                        {/* <DateRangePicker
                      className="SbaDateRage text-dark"
                      placeholder="Select Date Range"
                      value={[
                        startDate ? moment(startDate).toDate() : new Date(),
                        endDate ? moment(endDate).toDate() : new Date(),
                      ]}
                      format="MM/dd/yyyy"
                      block
                      character=" - "
                      onChange={handleDateChange}
                    /> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 d-flex gap-3 align-items-end">
                                                <button
                                                    // type="submit"
                                                    className="p-sm-btn mx-1"
                                                    onClick={gobtnClick}
                                                >
                                                    Enter
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="p-sm-btn"
                                                    onClick={()=>{ResetbtnClick()}}
                                                >
                                                    Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="performance bg-white m-3 p-border rounded">
                                        <div className="d-flex justify-content-between p-border-bottom p-3">
                                            {selectedTabOption === "0" && (
                                                <>
                                                    <div>
                                                        <p className="fw-semibold mb-2">
                                                            Monthly Performance for{" "}
                                                            {marketdatadetails.MarketIndexShortName}
                                                        </p>
                                                        <span className="font-sm">
                                                            Showing Results for {errorMsg !== true ? posNegLen : 0}{" "}
                                                            Months
                                                        </span>
                                                    </div>
                                                </>
                                            )}
                                            {selectedTabOption === "1" && (
                                                <>
                                                    <div>
                                                        <p className="fw-semibold mb-2">
                                                            {marketdatadetails.MarketIndexShortName}
                                                        </p>
                                                        <span className="font-sm">Statistics Summary</span>
                                                    </div>
                                                </>
                                            )}
                                            <div className="w-25">
                                                <label htmlFor="select fund" className="mb-1">
                                                    Select Statistics
                                                </label>
                                                <select
                                                    className="form-select"
                                                    aria-label="Default select example"
                                                    defaultValue={selectedTabOption}
                                                    onChange={tabOptionChange}
                                                >
                                                    {options.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        {(
                                            <>
                                                {selectedTabOption === "0" && (
                                                    <>
                                                        <div className="row p-border-bottom m-0">
                                                            <div className="col-md-3">
                                                                <div className="py-3 px-1">
                                                                    <label
                                                                        for="select fund"
                                                                        className="mb-1 label fw-medium fs-12"
                                                                    >
                                                                        Select BMI 1
                                                                    </label>
                                                                    <select
                                                                        className="form-select input-default"
                                                                        aria-label="Default select example"
                                                                        disabled
                                                                    >
                                                                        <option selected>{BM1}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="py-3 px-1">
                                                                    <label
                                                                        for="select fund"
                                                                        className="mb-1 label fw-medium fs-12"
                                                                    >
                                                                        Select BMI 2
                                                                    </label>
                                                                    <select
                                                                        className="form-select input-default"
                                                                        aria-label="Default select example"
                                                                        disabled
                                                                    >
                                                                        <option selected>{BM2}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row p-3">
                                                            <div className="col-md-6">
                                                                <div className="d-inline-flex ">
                                                                    <button
                                                                        className={`toggle-btn rounded-start ${gridbuttonActive && "active"
                                                                            }`}
                                                                        onClick={() => ReturnGridValue()}
                                                                    >
                                                                        <span>
                                                                            <img
                                                                                src={burgermenu}
                                                                                alt=""
                                                                                style={{
                                                                                    filter: gridbuttonActive
                                                                                        ? "brightness(100%)"
                                                                                        : "brightness(50%)",
                                                                                }}
                                                                            />
                                                                        </span>{" "}
                                                                        Grid View
                                                                    </button>
                                                                    <button
                                                                        className={`toggle-btn rounded-end ${chartbuttonActive && "active"
                                                                            }`}
                                                                        onClick={() => ReturnChartValue()}
                                                                    >
                                                                        <span>
                                                                            <img
                                                                                src={linechartup}
                                                                                alt=""
                                                                                style={{
                                                                                    filter: chartbuttonActive
                                                                                        ? "brightness(100%)"
                                                                                        : "brightness(50%)",
                                                                                }}
                                                                            />
                                                                        </span>{" "}
                                                                        Chart View
                                                                    </button>
                                                                    <div className="YearRG d-flex gap my-auto">
                                                                        <span className="radioSelectorGroup">
                                                                            <div>
                                                                                <span
                                                                                    className={
                                                                                        radioValue === 0
                                                                                            ? "selected YearRadioSpan"
                                                                                            : "YearRadioSpan"
                                                                                    }
                                                                                    onClick={getstdYear}
                                                                                >
                                                                                    1Y
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                <span
                                                                                    className={
                                                                                        radioValue === 1
                                                                                            ? "selected YearRadioSpan"
                                                                                            : "YearRadioSpan"
                                                                                    }
                                                                                    onClick={getstdYear}
                                                                                >
                                                                                    3Y
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                <span
                                                                                    className={
                                                                                        radioValue === 2
                                                                                            ? "selected YearRadioSpan"
                                                                                            : "YearRadioSpan"
                                                                                    }
                                                                                    onClick={getstdYear}
                                                                                >
                                                                                    5Y
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                <span
                                                                                    className={
                                                                                        radioValue === 3
                                                                                            ? "selected YearRadioSpan"
                                                                                            : "YearRadioSpan"
                                                                                    }
                                                                                    onClick={getstdYear}
                                                                                >
                                                                                    10Y
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                <span
                                                                                    className={
                                                                                        radioValue === 4
                                                                                            ? "selected YearRadioSpan"
                                                                                            : "YearRadioSpan"
                                                                                    }
                                                                                    onClick={getstdYear}
                                                                                >
                                                                                    ITD
                                                                                </span>
                                                                            </div>
                                                                            <div>
                                                                                {flagValues === true ? (
                                                                                    <span
                                                                                        className={
                                                                                            radioValue === 5 && flagValues === true
                                                                                                ? "selected YearRadioSpan"
                                                                                                : "YearRadioSpan"
                                                                                        }
                                                                                        onClick={getstdYear}
                                                                                    >
                                                                                        Custom
                                                                                    </span>
                                                                                ) : (
                                                                                    <span disabled={true}>Custom</span>
                                                                                )}
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 d-flex">
                                                                <div className="ms-auto">
                                                                    {!chartbuttonActive && (
                                                                        <>
                                                                            <button
                                                                                className="p-sm-btn me-3"
                                                                                onClick={handleButtonClick}
                                                                                disabled={!isEditable}
                                                                            >
                                                                                <img className="me-2" src={asset} alt="" />
                                                                                Post Returns
                                                                            </button>
                                                                            <button
                                                                                className="p-sm-btn"
                                                                                onClick={() => {
                                                                                    exportToExcel(ReturnsExcel, "Returns.xlsx");
                                                                                }}
                                                                            >
                                                                                <img src={download} alt="" />
                                                                                Export
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                    {chartbuttonActive === true && (
                                                                        <div className="button-container">
                                                                            {chartButtonNames.map((option) => (
                                                                                <button
                                                                                    key={option.value}
                                                                                    value={option.value}
                                                                                    className={`non-gappable-button ${selectedChartButton === option.label
                                                                                            ? "selected-non-gappable-button"
                                                                                            : ""
                                                                                        }`}
                                                                                    onClick={() => chartButtonClick(option.label)}
                                                                                    disabled={option.disabled}
                                                                                >
                                                                                    {option.label}
                                                                                </button>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {gridbuttonActive === true && (
                                                            <div>
                                                                <ReturnsTab
                                                                    isGridView={gridView}
                                                                    ReturnsExcel={ReturnsExcel}
                                                                />
                                                            </div>
                                                        )}
                                                        {!gridbuttonActive && selectedChartButton === "VAMI" && (
                                                            <div>
                                                                <VamiChart
                                                                    isChartView={chartView}
                                                                    startDate={startDate}
                                                                    endDate={endDate}
                                                                    radioValue={radioValue}
                                                                    setEndDate={setEndDate}
                                                                    setStartDate={setStartDate}
                                                                    customRange={customRange}
                                                                />
                                                            </div>
                                                        )}

                                                        {
                                                            !gridbuttonActive && selectedChartButton === "Rolling" && (
                                                                <div>

                                                                    {radioValue && radioValue.length > 0 ? (
                                                                        <RollingChart
                                                                            currentAsset={marketdatadetails?.MarketIndexName}
                                                                            isBM1Id={bM1Id}
                                                                            isBM2Id={bM2Id}
                                                                        />
                                                                    ) : (
                                                                        <p style={{ color: 'red', textAlign: 'center' }}>No Data Found</p>
                                                                    )}

                                                                </div>
                                                            )
                                                        }
                                                        {!gridbuttonActive && selectedChartButton === "CUMM" && (
                                                            <div>
                                                                <CumulativeReturnsChart
                                                                    startDate={startDate}
                                                                    endDate={endDate}
                                                                    radioValue={radioValue}
                                                                />
                                                            </div>
                                                        )}
                                                        {!gridbuttonActive && selectedChartButton === "DISTR" && (
                                                            <div>
                                                                <DistReturnsChart
                                                                    startDate={startDate}
                                                                    endDate={endDate}
                                                                    radioValue={radioValue}
                                                                />
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                                {selectedTabOption === "1" && (
                                                    <>
                                                        <div className="row p-border-bottom m-0">
                                                            <div className="col-md-3">
                                                                <div className="py-3 px-1">
                                                                    <label
                                                                        for="select fund"
                                                                        className="mb-1 label fw-medium fs-12"
                                                                    >
                                                                        Select BMI 1
                                                                    </label>
                                                                    <select
                                                                        className="form-select input-default"
                                                                        aria-label="Default select example"
                                                                        disabled
                                                                    >
                                                                        <option selected>{BM1}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="py-3 px-1">
                                                                    <label
                                                                        for="select fund"
                                                                        className="mb-1 label fw-medium fs-12"
                                                                    >
                                                                        Select BMI 2
                                                                    </label>
                                                                    <select
                                                                        className="form-select input-default"
                                                                        aria-label="Default select example"
                                                                        disabled
                                                                    >
                                                                        <option selected>{BM2}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 d-flex align-items-end justify-content-end p-3">
                                                                {updateShow && (
                                                                    <button
                                                                        className="p-sm-btn mx-1"
                                                                        onClick={updateSummarySettingsButton}
                                                                    >
                                                                        <img
                                                                            src={Settingicon}
                                                                            alt=""
                                                                            className="WhiteImage"
                                                                        />
                                                                        Modify View
                                                                    </button>
                                                                )}
                                                                {cancelShow && (
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <button
                                                                            className="s-sm-btn mx-1"
                                                                            onClick={cancelSummarySettingsButton}
                                                                        >
                                                                            <img src={Settingicon} alt="" /> Cancel Settings
                                                                        </button>
                                                                        <button className="p-sm-btn mx-1" onClick={SetSaveSettings}>Save</button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div class="m-0 py-3">
                                                            <SummaryTab
                                                            summarydata={summarydata}
                                                                showIcon={showIcon}
                                                                cancelShow={cancelShow}
                                                                CalendarExcel={CalendarExcel}
                                                                IsSave={IsSave}
                                                                setIsSave={setIsSave}
                                                                setcancelshow={setcancelshow}
                                                                setupdateshow={setupdateshow}
                                                                SummaryWidgetCollections={SummaryWidgetCollections}
                                                                WidgetPosition={WidgetPosition}
                                                                MktIndexName={marketdatadetails.MarketIndexName}
                                                                RadioValue={radioValue}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {selectedTabOption === "2" && (
                                                    <>
                                                        <div className="d-flex justify-content-end align-items-center p-3">
                                                            <button
                                                                type="button"
                                                                className="enter-btn"
                                                                onClick={() => {
                                                                    exportToExcel(
                                                                        CalendarExcel,
                                                                        "Performance Calendar Years.xlsx"
                                                                    );
                                                                }}
                                                            >
                                                                <img src={download} alt="" />
                                                                Export
                                                            </button>
                                                        </div>
                                                        <div></div>
                                                    </>
                                                )}
                                                {selectedTabOption === "3" && <></>}
                                            </>
                                        )}
                                    </div>
                                </>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <ToastContainer></ToastContainer>
        </>
    );
};
